import axios from 'axios';

export const backendApi = import.meta.env.VITE_APP_ENDPOINT;

/**
 * Creates an axios instance without authentication headers
 * Used for public endpoints that don't require authentication
 */
export default function publicAxiosInstance() {
  const axiosInstance = axios.create({
    baseURL: backendApi,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Response Interceptor for error handling
  axiosInstance.interceptors.response.use(
    response => {
      return response;
    },
    async error => {
      // Handle specific errors
      if (error.message === 'Network Error') {
        return Promise.reject({
          open: true,
          type: 'error',
          status: error?.response?.status,
          message: 'Network Error',
        });
      }

      if (!error.response) {
        return Promise.reject({
          open: true,
          type: 'error',
          message: error.message || 'Something went wrong.',
          status: error?.response?.status,
        });
      }

      return Promise.reject({
        open: true,
        type: 'error',
        message:
          error.response.data?.error || 
          error.response.data?.message || 
          'Something went wrong.',
        status: error.response.status,
      });
    }
  );

  return axiosInstance;
}

